import { createApp } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import FormKitBuilderContainer from 'shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue';
import EasyContactWidget from './easyContactWidget.vue';

async function mountCommunicationChannel() {
	const easyContactWidgetMount = document.getElementById('easy-contact-widget');

	if (!easyContactWidgetMount) {
		console.warn('[communicationChannel] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'easy-contact widget',
	});
	app.component('easy-contact-widget', EasyContactWidget);
	app.component('form-kit-builder-container', FormKitBuilderContainer);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(easyContactWidgetMount);
}

mountCommunicationChannel().catch((error) => {
	console.error('Error mounting CommunicationChannel:', error);
});

